import { observable } from 'mobx';
import { createContext } from 'react';

export const browserRequestHosts = observable.map<string, HTMLDivElement>(
  undefined,
  { deep: false }
);

export const BrowserRequestPresentationContext = createContext<{
  inlineTarget: HTMLElement | null;
} | null>(null);
